import { useTranslationInspector } from './hooks/useTranslationInspector';
import { InspectorButton } from './InspectorButton';
import { InspectorHighlight } from './InspectorHighlight';
import { InspectorPanel } from './InspectorPanel';

/**
 * Staff tool: point at any text on the page to see its translation key, copy
 * it, and edit its text in every locale.
 */
export function TranslationInspector({ left }: { left: number }) {
  const inspector = useTranslationInspector();
  if (!inspector.canInspect) return null;

  return (
    <>
      <InspectorButton
        active={inspector.active}
        left={left}
        onToggle={inspector.toggle}
      />
      {inspector.hovered && <InspectorHighlight target={inspector.hovered} />}
      {inspector.selected && (
        <InspectorPanel
          keys={inspector.selected}
          onClose={inspector.closePanel}
        />
      )}
    </>
  );
}
